import { useCallback, useRef } from 'react';
import type { IRecord } from '@platform/core/types';

/**
 * Записи, які список уже бачив (сторінки списку, «Вибрати все»): за ідентифікатором — для дій над вибраними записами з інших сторінок
 * (копіювання, експорт за кодами). `remember` додає записи, `pick` повертає відомі записи за ідентифікаторами в порядку вибору.
 */
export function useKnownRecords(): { remember: (items: readonly IRecord[] | undefined) => void; pick: (ids: readonly string[]) => IRecord[] } {
  const known = useRef(new Map<string, IRecord>());
  const remember = useCallback((items: readonly IRecord[] | undefined) => { for (const r of items ?? []) known.current.set(r.id, r); }, []);
  const pick = useCallback((ids: readonly string[]) => ids.map((id) => known.current.get(id)).filter((r): r is IRecord => !!r), []);
  return { remember, pick };
}
